// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"415":"c2aa2008","616":"8e3882c4","701":"f7d28639","853":"b512ec81","992":"892ce2a3"}[chunkId] + ".chunk.css";
};